import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { MapView } from "@abaco/map-web-module/src/modules/map-web-module/models/AbacoMap";
import { FarmScsCompetency, MapChecklist } from "./models";

export default class SoilHealthVuexWidgetModule extends AbacoVuexModule {
    @State() globalMapView!: MapView | null;
    @State({ default: null }) currentCheckId!: number | null;
    @State({ default: null }) currentCheck!: MapChecklist | null;

    @State() scsCompetency!: FarmScsCompetency | null;
    @State({ default: "FARM" }) selectedScsParam!: string;
    @State({ default: 0 }) zoomOnTableSelectedCheck!: number;
    @State({ default: null }) samplingPointsStartDate!: Date | null;
    @State({ default: null }) samplingPointsEndDate!: Date | null;
    @State({ default: false }) samplingPointsDatesLoaded!: boolean;
    @State({ default: false }) samplingPointsMain!: boolean;
}
